import React, { useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const ValueFirstbulbsection = () => {
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        // Scroll-triggered animation for the bulb image
        gsap.fromTo(
            ".bulb-image",
            {
                opacity: 0,
                y: -50
            },
            {
                opacity: 1,
                y: 0,
                duration: 2,
                ease: "ease-in-out",
                scrollTrigger: {
                    trigger: ".bulb-image",
                    start: "top 80%",  // Trigger when 80% of the image is in the viewport
                    end: "bottom top", // End the animation when the image goes out of view
                    toggleActions: "play none none none", // Trigger only once
                },
            }
        );
    }, []);

    return (
        <>
            <section className="value-navigator-section" style={{ background: "rgb(197 235 243)",height:'500px' }}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {/* Image Section */}
                        <div className="col-12 col-md-4">
                            <div
                                className="img-container"
                                data-aos="fade-down"
                                data-aos-offset="100"
                                data-aos-duration="800"
                                data-aos-easing="ease-in-sine"
                            >
                                <img
                                    className="lazyloaded bulb-image"  // Added class for specific styling
                                    src="https://f.hubspotusercontent40.net/hubfs/5724847/Cnt_VF_LP_Images/bulb-image.png"
                                    
                                    alt="bulb"
                                    style={{ maxWidth: "100%", height: "auto" }}
                                />
                            </div>
                        </div>

                        {/* Text Section */}
                        <div className="col-12 col-md-8 pt-3 pt-md-0">
                            <div
                                className="details text-center"
                                data-aos="fade-left"
                                data-aos-offset="100"
                                data-aos-duration="800"
                                data-aos-easing="ease-in-sine"
                            >
                                <h2 style={{textAlign:'left', fontSize:"50px"}}>
                                    Every Envisionist is a brand ambassador of a time-tested value
                                    system.
                                </h2>
                                <div className="action text-left">
                                    <button
                                        id="mybtn"
                                        onClick={toggleModal}
                                        style={{
                                            backgroundColor: "#000",  // Add a background color
                                            border: "none",
                                            color: "white",               // Text color for better contrast
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            borderRadius: "8px",         // Rounded corners
                                            padding: "10px 20px",        // Add some padding for better spacing
                                            textDecoration:"none",
                                        }}
                                    >
                                        Share Your ValuesFIRST Experience
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal */}
                {modalOpen && (
                    <div id="modelimage" className="modal">
                        <div className="vertical-alignment-helper image-bg-box">
                            <div className="modal-dialog vertical-align-center">
                                <div className="modal-content">
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={toggleModal}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            fontSize: "1.5rem",
                                            position: "absolute",
                                            right: "10px",
                                            top: "10px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        ×
                                    </button>
                                    <div className="modal-body">
                                        <h3>Share Your Experience</h3>
                                        <form>
                                            <div className="form-group">
                                                <label htmlFor="email">Email*</label>
                                                <input
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    placeholder="Enter your email"
                                                    className="form-control"
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="linkedin">LinkedIn Profile</label>
                                                <input
                                                    id="linkedin"
                                                    name="linkedin"
                                                    type="text"
                                                    placeholder="LinkedIn profile URL"
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="message">Message</label>
                                                <textarea
                                                    id="message"
                                                    name="message"
                                                    placeholder="Enter your message"
                                                    className="form-control"
                                                ></textarea>
                                            </div>
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </>
    );
};

export default ValueFirstbulbsection;
